import { memo, useMemo } from "react";
// import removeImg from "assets/svgs/close.svg";
import ImageUpdate from "./ImageUpdate";
import { getId } from "../../helpers/data/navbar";

const SlidersArray = ({ sliders, setSliders }) => {
	const getOptionsByName = arr =>
		arr?.map(i => ({ value: getId(i), label: i?.name?.["ar"] })) || [];

	const handleInputOnChange = (e, targetIndex) => {
		const { name, value } = e?.target || e;

		const newSlidersArray = sliders?.map((slider, index) => {
			if (targetIndex !== index) return slider;

			// make an object with locals inside the big one
			const inputName = name?.split(".")?.[0];
			const local = name?.split(".")?.[1];

			if (local) {
				return {
					...slider,
					[inputName]: {
						...slider?.[inputName],
						[local]: value,
					},
				};
			}
			return { ...slider, [name]: value };
		});
		setSliders(newSlidersArray);
	};

	const removeSlider = targetIndex => {
		const newSliders = sliders.filter((slider, index) => {
			return index !== targetIndex;
		});
		setSliders(() => newSliders);
	};

	const addSlider = () => {
		setSliders(() => [...sliders, {}]);
	};

	const renderSlides = useMemo(
		() =>
			sliders.map((slider, index) => (
				<Slide
					key={index}
					{...{
						index,
						removeSlider,
						slider,
						sliders,
						setSliders,
						handleInputOnChange,
						getOptionsByName,
					}}
				/>
			)),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[setSliders, JSON.stringify(sliders)]
	);

	return (
		<div className="form-group branches sliders">
			<div className="row">
				<div className="col-12">{renderSlides}</div>

				<div className="text-left mt-2 col-12">
					<button
						type="button"
						className="btn btn-info add_new_section__ mt-2"
						onClick={() => {
							addSlider();
						}}
					>
						اضافة
					</button>
				</div>
			</div>
		</div>
	);
};

const Slide = memo(
	({
		index,
		removeSlider,
		slider,
		sliders,
		setSliders,
		handleInputOnChange,
		getOptionsByName,
	}) => {
		return (
			<>
				<label
					htmlFor={` `}
					className="add-multi-component w-100 cursor-pointer card card-body"
				>
					<div>
						<button
							type="button"
							onClick={() => removeSlider(index)}
							className="removeImg btn-close btn-danger bg-danger"
						></button>

						<span className="h4">
							{" - "}
							{index + 1}
						</span>
					</div>
					<div className="row">
						<div className="col-12" lg={12}>
							<ImageUpdate
								item={slider}
								sliders={sliders}
								setSliders={setSliders}
								index={index}
							/>
						</div>

						<div className="col-12 col-md-6">
							<div className="form-item">
								<label htmlFor="subTitleAr">العنوان باللغة العربية</label>
								<input
									type="text"
									name="title.ar"
									value={slider?.title?.ar}
									id="subTitleAr"
									onChange={e => handleInputOnChange(e, index)}
								/>
							</div>
						</div>
						<div className="col-12 col-md-6">
							<div className="form-item">
								<label htmlFor="subTitleEn">العنوان بالغة الانجليزية</label>
								<input
									type="text"
									name="title.en"
									value={slider?.title?.en}
									id="subTitleEn"
									onChange={e => handleInputOnChange(e, index)}
								/>
							</div>
						</div>
						<div className="col-12 col-md-6">
							<div className="form-item">
								<label htmlFor="descriptionAr">الوصف باللغة العربية</label>
								<textarea
									name="description.ar"
									value={slider?.description?.ar}
									id="descriptionAr"
									cols="30"
									rows="3"
									onChange={e => handleInputOnChange(e, index)}
								></textarea>
							</div>
						</div>
						<div className="col-12 col-md-6">
							<div className="form-item">
								<label htmlFor="descriptionEn">الوصف بالغة الانجليزية</label>
								<textarea
									name="description.en"
									value={slider?.description?.en}
									id="descriptionEn"
									cols="30"
									rows="3"
									onChange={e => handleInputOnChange(e, index)}
								></textarea>
							</div>
						</div>
					</div>
				</label>
			</>
		);
	}
);

export default SlidersArray;
